/**
 * Geçmiş dönem başkanları (dönem + isim). Fotoğraf: `image` URL veya null.
 * @typedef {{ period: string, name: string, image?: string | null }} PastPresident
 */

/**
 * i18n `pastPresidents.fallbackItems` (returnObjects) → PastPresident[].
 * @param {unknown} raw
 * @returns {PastPresident[]}
 */
export function mapPastPresidentsFallbackFromI18n(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((x) => x && typeof x === 'object')
        .map((x) => {
            const o = /** @type {{ period?: unknown, name?: unknown }} */ (x);
            return {
                period: String(o.period ?? ''),
                name: String(o.name ?? ''),
                image: null,
            };
        })
        .filter((p) => p.period && p.name);
}
